import { defineStore } from 'pinia';
import { FilterItem, RealtimeReportFilter, RealtimeReportState } from '@/types';

const getDefaultState = (): RealtimeReportState => ({
    filter: {
        queues: [],
    },
});

export const useRealtimeReportStore = defineStore('realtimeReportStore', {
    state: getDefaultState,

    getters: {
        defaultFilter: () => {
            return getDefaultState().filter;
        },
        activeFilters: (state): Array<FilterItem> => {
            const filters: Array<FilterItem> = [];

            for (const q of state.filter.queues) {
                filters.push({
                    id: q.id,
                    field: 'queue',
                    value: q.name,
                    label: q.name,
                } as FilterItem);
            }

            return filters;
        },
        queuesIds: (state): Array<number> => {
            return state.filter.queues.map((q) => q.id);
        },
    },
    actions: {
        applyFilters(filter: RealtimeReportFilter) {
            this.filter.queues = filter.queues;
        },
        clearFilter(item?: FilterItem) {
            if (item === undefined) {
                this.filter.queues = getDefaultState().filter.queues;
            } else {
                if (item.field === 'queue') {
                    this.filter.queues = this.filter.queues.filter((q) => q.id !== item.id);
                }
            }
        },
    },
});
